module.exports = __webpack_public_path__ + "static/media/file-icon.ab8b4a14.jpg";